// extracted by mini-css-extract-plugin
export default {"outerContainer":"T0mLjU","container":"XljORf","timer":"bgbtCF","timerTextContainer":"jfTFnx","timerText":"mTAKq7","timerTime":"bFXxS3"};